import React from "react";
import { BookOpen, Youtube, Linkedin, Play, ArrowRight, ExternalLink } from "lucide-react";

export default function Resources() {
  const hubs = [
    {
      type: "LinkedIn Career Insights",
      icon: <Linkedin className="w-5 h-5 text-[#F4C300]" />,
      title: "Daily Tactical Breakdowns on Leadership",
      desc: "Micro-articles breaking down corporate politics, executive presence parameters, and direct outreach scripting techniques.",
      link: "https://www.linkedin.com/in/suhasini-basa-pmp"
    },
    {
      type: "YouTube Masterclasses",
      icon: <Youtube className="w-5 h-5 text-[#F4C300]" />,
      title: "In-Depth BA & PM Progression Videos",
      desc: "Comprehensive strategy sessions covering business analysis structures, project delivery pipelines, and PMP navigation.",
      link: "https://www.linkedin.com/in/suhasini-basa-pmp" // fallback to linkedin as provided in brief
    },
    {
      type: "Interactive Academy",
      icon: <BookOpen className="w-5 h-5 text-[#F4C300]" />,
      title: "Suhasini Basa Learning Ecosystem",
      desc: "Our primary, dedicated, high-contrast, structured educational programs and cohort coaching checkpoints.",
      link: "https://academy.suhasinibasa.com/"
    }
  ];

  return (
    <div className="relative bg-obsidian text-slate-100 min-h-screen">
      <div className="noise-overlay" />

      {/* Header */}
      <section className="relative py-20 lg:py-28 px-4 sm:px-6 lg:px-12 border-b border-white/5 overflow-hidden">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-gold/5 rounded-full blur-[120px] pointer-events-none" />
        <div className="max-w-4xl mx-auto text-left space-y-6 relative z-10">
          <span className="text-xs uppercase tracking-[0.25em] text-gold font-mono font-bold">RESOURCES HUB</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-tight">
            Learn with Suhasini Basa
          </h1>
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed font-normal">
            Your centralized business and educational resource center. Discover tactical YouTube series, professional micro-articles, and customized templates.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-12 bg-navy relative border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {hubs.map((hub, idx) => (
              <div 
                key={idx}
                className="bg-obsidian border border-white/5 p-8 flex flex-col justify-between hover:border-gold/20 transition-all duration-300"
              >
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="font-mono text-[10px] text-gold uppercase tracking-widest font-bold">
                      {hub.type}
                    </span>
                    {hub.icon}
                  </div>
                  <h3 className="font-display text-lg font-bold text-white leading-snug">{hub.title}</h3>
                  <p className="text-slate-400 text-sm leading-relaxed">{hub.desc}</p>
                </div>
                
                <a
                  href={hub.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`resources-hub-link-${idx}`}
                  className="mt-8 inline-flex items-center justify-between bg-white/5 hover:bg-white/10 text-white font-mono text-xs uppercase tracking-widest px-4 py-3 transition-colors duration-200"
                >
                  <span>Explore Platform</span>
                  <ExternalLink className="w-4 h-4 text-gold" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
